// modules/admin/shared/permissionGuard.jsx
import React from "react";
import { hasP } from "../../../utils/commonfunction";
import NoPermission from "./NoPermission";


const PermissionGuard = ({ component: Component, permission }) => {
  const hasAccess = Array.isArray(permission)
    ? permission.some((p) => hasP(p))
    : hasP(permission);

  if (!hasAccess) {
    return <NoPermission />;
  }
  return <Component />;
};

export default PermissionGuard;